module.exports = __webpack_public_path__ + "static/media/8-hybrid.f4a31564.png";